import { render, staticRenderFns } from "./waybillFreightCost.vue?vue&type=template&id=a38e86ca&"
import script from "./waybillFreightCost.vue?vue&type=script&lang=js&"
export * from "./waybillFreightCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports